import { faArrowDown, faArrowLeft, faArrowRight, faArrowUp, faKeyboard, faMinus, faPlus, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import React, { useState } from "react";

const KeyboardShortcuts = ({ controls }) => {
    const [shortcutsVisible, setShortcutsVisibility] = useState(false);

    const icon = () => (
        <FontAwesomeIcon
            icon={shortcutsVisible ? faTimes : faKeyboard}
            onClick={() => {
                setShortcutsVisibility(!shortcutsVisible);
            }}
        />
    );

    return shortcutsVisible ? (
        <div className="keyboardShortcuts">
            <span className="keyboardShortcuts__Title">Keyboard Shortcuts</span>
            <div className="keyboardShortcuts__Items">
                {controls && controls.length ? (
                    <>
                        {controls.includes("up") && (
                            <Tooltip
                                title="Move up a step"
                                placement="left">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="up">
                                    <FontAwesomeIcon icon={faArrowUp} />
                                </div>
                            </Tooltip>
                        )}
                        {controls.includes("down") && (
                            <Tooltip
                                title="Move down a step"
                                placement="top">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="down">
                                    <FontAwesomeIcon icon={faArrowDown} />
                                </div>
                            </Tooltip>
                        )}
                        {controls.includes("pageUp") && (
                            <Tooltip
                                title="Move up a page"
                                placement="top">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="page-up">
                                    <span>PgUp</span>
                                </div>
                            </Tooltip>
                        )}
                        {controls.includes("pageDown") && (
                            <Tooltip
                                title="Move down a page"
                                placement="left">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="page-down">
                                    <span>PgDn</span>
                                </div>
                            </Tooltip>
                        )}
                        {controls.includes("left") && (
                            <Tooltip
                                title="Move left a step"
                                placement="top">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="left">
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </div>
                            </Tooltip>
                        )}
                        {controls.includes("right") && (
                            <Tooltip
                                title="Move right a step"
                                placement="top">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="right">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </div>
                            </Tooltip>
                        )}
                        {controls.includes("pageLeft") && (
                            <Tooltip
                                title="Move left a page"
                                placement="top">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="page-left">
                                    <span>PgUp</span>
                                </div>
                            </Tooltip>
                        )}
                        {controls.includes("pageRight") && (
                            <Tooltip
                                title="Move right a page"
                                placement="left">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="page-right">
                                    <span>PgDn</span>
                                </div>
                            </Tooltip>
                        )}
                        {controls.includes("zoomOut") && (
                            <Tooltip
                                title="Zoom out"
                                placement="top">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="zoom-out">
                                    <FontAwesomeIcon icon={faMinus} />
                                </div>
                            </Tooltip>
                        )}
                        {controls.includes("zoomIn") && (
                            <Tooltip
                                title="Zoom in"
                                placement="top">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="zoom-in">
                                    <FontAwesomeIcon icon={faPlus} />
                                </div>
                            </Tooltip>
                        )}

                        {controls.includes("annotate") && (
                            <Tooltip
                                title="Toggle place annotation mode"
                                placement="left">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="a">
                                    <span>A</span>
                                </div>
                            </Tooltip>
                        )}
                        {controls.includes("bookmark") && (
                            <Tooltip
                                title="Toggle place bookmark mode"
                                placement="bottom">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="b">
                                    <span>B</span>
                                </div>
                            </Tooltip>
                        )}
                        {controls.includes("flip") && (
                            <Tooltip
                                title="Flip horizontal direction"
                                placement="bottom">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="f">
                                    <span>F</span>
                                </div>
                            </Tooltip>
                        )}
                        {controls.includes("magnify") && (
                            <Tooltip
                                title="Toggle magnifying glass"
                                placement="bottom">
                                <div
                                    className="keyboardShortcuts__Items__Item"
                                    key="m">
                                    <span>M</span>
                                </div>
                            </Tooltip>
                        )}
                    </>
                ) : null}
            </div>
            <div className="closeIcon">{icon()}</div>
        </div>
    ) : (
        <div className="keyboardShortcutsIcon">{icon()}</div>
    );
};

export default KeyboardShortcuts;
